import { combineReducers } from "redux";
import videoReducer from "./videoreducers";

const rootReducer = combineReducers({
  videoData: videoReducer,
});

export default rootReducer;
